import { useMagasinStore } from "@/store/magasin";

export default defineNuxtRouteMiddleware(async (route) => {

  const nuxtApp = useNuxtApp();

  if (process.server || (process.client && nuxtApp.isHydrating && nuxtApp.payload.serverRendered)) {
    return;
  }

  const magasinStore = useMagasinStore(nuxtApp.$pinia);

  const magasinId = getMagasinFromQueryUrl(route.query);
  if (magasinId) {
    await magasinStore.switchMagasin(magasinId);
  }
});

const getMagasinFromQueryUrl = (query) => {
  const magasinId = Number(query.magasin_id);
  if (isNaN(magasinId)) {
    return null;
  }
  return magasinId;
}
